var render = function render(){var _vm=this,_c=_vm._self._c;return _c('MainContent',[(_vm.selectActiveCompany)?_c('div',{key:_vm.selectActiveCompany._id,staticClass:"container-fluid"},[(_vm.showOrgCampaigns)?_c('CampaignSetupsView'):_c('CampaignList')],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }